/* ============================================================
   Kab Libey — shared theme JS (Shopify)
   ============================================================ */
(function () {
  'use strict';

  /* ── Mobile menu ─────────────────────────────────────────── */
  var burger = document.getElementById('burger');
  var menuPanel = document.getElementById('menuPanel');
  if (burger && menuPanel) {
    burger.addEventListener('click', function () {
      var open = menuPanel.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
    });
    menuPanel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menuPanel.classList.remove('open');
        burger.setAttribute('aria-expanded', false);
      });
    });
  }

  /* ── Search overlay open / close ─────────────────────────── */
  var klSearch = document.getElementById('klSearch');
  var searchOpenBtns = document.querySelectorAll('.search-btn');
  var klSearchClose = document.getElementById('klSearchClose');
  var klSearchInput = document.getElementById('klSearchInput');
  function openSearch() { if (!klSearch) return; klSearch.classList.add('open'); klSearch.setAttribute('aria-hidden', 'false'); if (klSearchInput) setTimeout(function () { klSearchInput.focus(); }, 60); }
  function closeSearch() { if (!klSearch) return; klSearch.classList.remove('open'); klSearch.setAttribute('aria-hidden', 'true'); }
  searchOpenBtns.forEach(function (b) { b.addEventListener('click', openSearch); });
  if (klSearchClose) klSearchClose.addEventListener('click', closeSearch);
  if (klSearch) klSearch.addEventListener('click', function (e) { if (e.target === klSearch) closeSearch(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
  /* Prompt chips are real collection-filter links, so they remain usable
     without JavaScript and never create a bulky search-results page. */

  /* ── Scroll reveals ──────────────────────────────────────── */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ── Cart count helpers ──────────────────────────────────── */
  function paintCount(count) {
    document.querySelectorAll('#cartCount, .cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.classList.add('show'); else el.classList.remove('show');
    });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCount(cart.item_count); })
      .catch(function () {});
  }
  refreshCount();

  /* ── AJAX add to cart (all "Add to cart" buttons) ────────── */
  function sparkle(btn) {
    var chars = ['\u2726', '\u2727', '\u2665', '\u2726', '\u2665', '\u2727'];
    for (var k = 0; k < 6; k++) {
      var s = document.createElement('span'); s.className = 'spark'; s.textContent = chars[k];
      var a = (Math.PI * 2 * k) / 6 + Math.random() * 0.5, d = 40 + Math.random() * 24;
      s.style.setProperty('--sx', Math.cos(a) * d + 'px');
      s.style.setProperty('--sy', Math.sin(a) * d + 'px');
      s.style.setProperty('--sr', (Math.random() * 70 - 35) + 'deg');
      s.style.color = ['#F05435', '#ED218A', '#FACE21', '#B2D99D'][k % 4];
      btn.appendChild(s); (function (sp) { setTimeout(function () { sp.remove(); }, 750); })(s);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.atc, .add-bag');
    if (!btn) return;
    // Context: a product form (product page) or a product card (grid)
    var form = btn.closest('form');
    var card = btn.closest('.product, .product-card');
    var variantId = btn.dataset.variantId || '';
    if (!variantId && form) { var fi = form.querySelector('[name="id"]'); if (fi) variantId = fi.value; }
    if (!variantId && card) { var ci = card.querySelector('[name="id"]'); if (ci) variantId = ci.value; }
    if (!variantId) return; // not an add-to-cart context

    e.preventDefault();
    if (btn.disabled) return;

    // gather quantity + properties
    var scope = form || card || document;
    var body = { items: [{ id: variantId, quantity: 1 }] };
    var qtyEl = scope.querySelector('[name="quantity"]');
    if (qtyEl && qtyEl.value) body.items[0].quantity = parseInt(qtyEl.value) || 1;
    var props = {};
    scope.querySelectorAll('[name^="properties["]').forEach(function (p) {
      if (p.value) { var m = p.name.match(/properties\[(.+)\]/); if (m) props[m[1]] = p.value; }
    });
    if (Object.keys(props).length) body.items[0].properties = props;

    var label = btn.textContent;
    btn.classList.add('added');
    btn.textContent = 'Added \u2665';
    sparkle(btn);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCount(); })
      .catch(function () {})
      .finally(function () {
        setTimeout(function () { btn.classList.remove('added'); btn.textContent = label; }, 1500);
      });
  });
})();
